import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {useParams} from "react-router-dom";
import {PaymentGatewayService} from "../../../serverService/paymentGatewayService/PaymentGatewayService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {convertUniversalDateToPersianDate} from "../../../util/DateConvertor";
import {PaymentGatewayTypes} from "../../../serverService/enums/PaymentGatewayTypes"
import {
    RaikoBaseCardContainer, RaikoButtonPrimary, RaikoCustomSelect, raikoCustomSelectItemGenerator, RaikoFlexAlignEnd,
    RaikoGridOneColumn, RaikoGridTwoColumn,
    RaikoLabel, RaikoSimpleInputOutlined,
    showErrorMessage,
    showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

export default function PaymentGatewayBaseInfo({setTitle}) {

    const {id: gateWayId} = useParams()

    const service = new PaymentGatewayService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof gateWayId !== 'undefined') {
            service.getGatewayInfo(gateWayId)
                .then(response => {
                    setGateway(response.title)
                    setType(response.type)
                    setCreateBy(response.createdBy)
                    setCreateAt(convertUniversalDateToPersianDate(response.createdAt))
                    setTitle(response.title)
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {

            })
        }
    }, [gateWayId]);

    const [gateway, setGateway] = useState("")
    const [type, setType] = useState(PaymentGatewayTypes.ZARINPAL.id)

    const [createAt, setCreateAt] = useState("");
    const [createBy, setCreateBy] = useState("");

    function handleUpdateInfo() {
        if (gateway.length > 0) {
            loading.show()
            service.updateGatewayInfo(gateWayId, gateway, type)
                .then(response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                    setTitle(response.title)

                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })

        } else {
            showWarningMessage("لطفا نام درگاه را وارد نمایید.")
        }
    }

    return (
        <RaikoGridOneColumn className={css`gap: 1.5rem`}>
            <RaikoBaseCardContainer className={css`margin-top: 16px;`}>
                <RaikoGridOneColumn>
                    <RaikoLabel text={"اطلاعات پایه"}/>
                    <RaikoGridTwoColumn>
                        <RaikoSimpleInputOutlined
                            labelText={"عنوان"}
                            setValue={setGateway}
                            value={gateway}/>

                        <RaikoCustomSelect
                            value={type}
                            setValue={setType}
                            labelText={"نوع"}
                            items={[
                                raikoCustomSelectItemGenerator(PaymentGatewayTypes.ZARINPAL.id, PaymentGatewayTypes.ZARINPAL.name)
                            ]}
                        />

                    </RaikoGridTwoColumn>
                    <RaikoFlexAlignEnd>
                        <RaikoButtonPrimary
                            label={"بروزرسانی"}
                            onClick={handleUpdateInfo}
                        />
                    </RaikoFlexAlignEnd>
                </RaikoGridOneColumn>

            </RaikoBaseCardContainer>

            <RaikoBaseCardContainer>
                <RaikoGridOneColumn>
                    <RaikoLabel text={"اطلاعات ساخت"}/>
                    <RaikoGridTwoColumn>
                        <RaikoSimpleInputOutlined labelText={"سازنده"} setValue={setCreateBy} value={createBy}
                                                  disabled/>
                        <RaikoSimpleInputOutlined labelText={"تاریخ ساخت"} setValue={setCreateAt} value={createAt}
                                                  disabled/>
                    </RaikoGridTwoColumn>
                </RaikoGridOneColumn>
            </RaikoBaseCardContainer>

        </RaikoGridOneColumn>

    )
}